import { jsx as _jsx, jsxs as _jsxs } from "tsx-dom/jsx-runtime";
import { text } from "../i18n.js";
/**
 * @returns The HTMLElement containing the hardware acceleration modal
 */
export function HardwareAcceleration() {
    return (_jsx("div", { id: "hardware-acceleration-modal", class: "modal hidden", children: _jsxs("div", { class: "modal-area", children: [_jsx("span", { class: "close-modal" }), _jsx("span", { id: "acceleration-text", children: text("enable-hardware-acceleration") }), _jsx("a", { href: "https://github.com/ruffle-rs/ruffle/wiki/Frequently-Asked-Questions-For-Users#chrome-hardware-acceleration", target: "_blank", class: "modal-button", children: text("enable-hardware-acceleration-link") })] }) }));
}
